import {
  FeatureGateName,
  WebinarListSection,
  deserify,
} from '@geneo2-web/shared-ui';
import { WebinarListRole } from '@geneo2-web/services-clients';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { useFeatureGate } from '../../../utils/customHooks';

export default function HomeWebinarList() {
  const webinarEnabled = useFeatureGate(FeatureGateName.webinarEnabled);
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const profileId = Number(user_info?.teacherProfileId ?? 0);
  const schoolId = Number(user_info?.schoolDetails?.[0]?.schoolId ?? 0);

  if (!webinarEnabled || !profileId || !schoolId) return null;

  return (
    <WebinarListSection
      title="Webinars"
      role={WebinarListRole.TEACHER}
      profileId={profileId}
      schoolId={schoolId}
      linkType="start"
      hideWhenEmpty
    />
  );
}
